// CANONICAL COPY: installations\smart-td\content\carrierAnswerLimitsTable.js (ruling 321 slice 3c, task list section 739). src\data\carrierAnswerLimitsTable.js is its
// projection, written by scripts\sync-installation.js - EDIT THE CANONICAL. An edit made only to the projection is refused by the cycle.
// DATA ONLY (section 739): lifted verbatim out of src\data\carrierAnswerLimits.js, which keeps the code and re-exports every name here.
// initialDays            - the carrier's answer to the claim as PRESENTED (clock starts at `presented`)
// appealDays             - a DISTINCT appeal-level number where the agreement gives one; null means
//                          the initial recurs (see the header note above).
// conferenceDecisionDays - the carrier's written decision after a claim is DISCUSSED in conference,
//                          from the date discussed; null where the agreement carries no such clock.
// provision / defaultAllowanceProvision - catalogued violation_ids, for the module's messages.
// cites                  - file:line into data\agreements\*, the quote VIO-1 proves.
export const CARRIER_ANSWER_LIMITS = {
  'CSX Yardmaster System Agreement (eff. July 1, 2002)': {
    initialDays: 60, appealDays: 75, conferenceDecisionDays: null,
    // Forensic audit 2026-10-16: the 75 days run "from the date appeal was receipted" (csx-2002-system-agreement
    // .source.txt:1996), so appealLadder.answerDue counts them from the appeal act's receivedOn where one is recorded.
    appealFrom: 'receipt',
    provision: 'CLAIM-carrier-response-limits',
    defaultAllowanceProvision: 'CLAIM-carrier-response-limits',
    cites: { initial: 'data/agreements/csx-2002-system-agreement.source.txt:1994',
             appeal:  'data/agreements/csx-2002-system-agreement.source.txt:1996' },
  },
  'Amtrak Yardmaster Agreement (eff. Jan 1, 1983; Labor Relations Printout, Nov 1, 2000)': {
    initialDays: 60, appealDays: null, conferenceDecisionDays: 60,
    // FORENSIC AUDIT 2026-10-16: Rule 29(f) (:692-694) carries to each succeeding officer only "the requirements ...
    // pertaining to appeal by the employee"; it does NOT carry the carrier's 60-day answer and its default. At appeal the
    // carrier's clock is the decision "within sixty (60) calendar days from date discussed" (:705, :711) - the conference
    // clock. So no answer clock (and no default) runs from an `appealed` act.
    appealAnswerStated: false,
    provision: 'CLAIM-carrier-response-limits',
    defaultAllowanceProvision: 'CLAIM-carrier-response-limits-default-allowance',
    cites: { initial: 'data/agreements/amtrak-ym-2000-11-01.txt:679',
             conference: 'data/agreements/amtrak-ym-2000-11-01.txt:705',
             successive: 'data/agreements/amtrak-ym-2000-11-01.txt:692' },
  },
  'Delaware & Hudson / Canadian Pacific Yardmaster Agreement (codified 2007)': {
    initialDays: 60, appealDays: null, conferenceDecisionDays: null,
    provision: 'CLAIM-carrier-response-limits',
    defaultAllowanceProvision: 'CLAIM-carrier-response-limits',
    cites: { initial: 'data/agreements/dh-codified-2007.source.txt:810' },
  },
  'Conrail Yardmasters Agreement (eff. July 1, 1978)': {
    initialDays: 60, appealDays: null, conferenceDecisionDays: 60,
    // FORENSIC AUDIT 2026-10-16: Rule 4-K-1(f) (:974-976) carries only the employee's appeal requirements to each
    // succeeding officer, as Amtrak 29(f). At appeal the carrier decides "within sixty (60) calendar days from date
    // discussed" (:992-993) - the conference clock. No answer clock or default runs from an `appealed` act.
    appealAnswerStated: false,
    provision: 'CLAIM-carrier-response-limits',
    defaultAllowanceProvision: 'CLAIM-carrier-response-limits',
    cites: { initial: 'data/agreements/conrail-rya-7-1-78.source.txt:953',
             conference: 'data/agreements/conrail-rya-7-1-78.source.txt:992',
             successive: 'data/agreements/conrail-rya-7-1-78.source.txt:974' },
  },
  'Conrail Mechanical Supervisors Agreement (modifications 1994)': {
    // FORENSIC AUDIT 2026-10-16: Rule 14(A) - "Decision by the Senior Director-Labor Relations will be made within thirty
    // (30) days from the date the claim is discussed" (:64). That is the appeal-level clock, from DISCUSSION; it was null
    // here, so the platform counted 30 days from the appeal instead.
    initialDays: 30, appealDays: null, conferenceDecisionDays: 30,
    appealAnswerStated: false,
    provision: 'CLAIM-carrier-response-limits',
    defaultAllowanceProvision: 'CLAIM-carrier-response-limits-default-allowance',
    cites: { initial: 'data/agreements/ConrailMS_modifications_1994.ocr.txt:60',
             conference: 'data/agreements/ConrailMS_modifications_1994.ocr.txt:64',
             default: 'data/agreements/ConrailMS_modifications_1994.ocr.txt:65' },
    note: 'OCR source. The 30 was confirmed 2026-09-25 but read from OCR text; verify against paper.',
  },
  // GO-341. Rule 24 C (claim) and Rule 24 D (appeal) both name sixty days; the appeal figure equals
  // the initial, so appealDays stays null (the initial recurs) and the appeal line is cited.
  'BN Yardmaster Agreement': {
    initialDays: 60, appealDays: null, conferenceDecisionDays: null,
    provision: 'CLAIM-carrier-response-limits',
    defaultAllowanceProvision: 'CLAIM-carrier-response-limits',
    cites: { initial: 'data/agreements/BN_YM_Schedule_1997-05-10.source.txt:1066',
             appeal:  'data/agreements/BN_YM_Schedule_1997-05-10.source.txt:1081' },
    note: 'Footnote to Rule 24 C (source.txt:1071-1073): the date of declination is the date the payroll printout is delivered to the employee, or for a letter claim the date the declination is delivered (mailed).',
  },
  // GO-256, added 2026-10-16 with the split (Bob: "wire both agreements' time limits now"). EXTRACTED, NOT YET CONFIRMED
  // by the SME as the 09-25 four were.
  // Metra Rule 23(c) (:834-836): the procedure "pertaining to appeal by the employee AND DECISION BY THE CARRIER, shall
  // govern in appeals taken to each succeeding officer" - so the 60 days and the default recur on appeal (appealDays null).
  'Metra (NIRC) Yardmaster Agreement (eff. Jan 1, 1984; rev. Sep 1, 2010)': {
    initialDays: 60, appealDays: null, conferenceDecisionDays: null,
    provision: 'CLAIM-carrier-response-limits',
    defaultAllowanceProvision: 'CLAIM-carrier-response-limits',
    cites: { initial: 'data/agreements/metra-nirc-ym-1984-rev2010.source.txt:818',
             default: 'data/agreements/metra-nirc-ym-1984-rev2010.source.txt:819',
             successive: 'data/agreements/metra-nirc-ym-1984-rev2010.source.txt:834',
             appeal: 'data/agreements/metra-nirc-ym-letter-2026-08-04-rule23b.source.txt:18' },
    // 2026-10-17 (ruling 318): Rule 23(b) as replaced by the letter of Aug 4, 2026 states the appeal figure in so many words -
    // "The Carrier will then have sixty (60) days to respond to the Organization's appeal" - the same 60, so appealDays stays null.
    note: 'Extracted 2026-10-16 from Rule 23(a) and (c); the appeal figure from Rule 23(b) as amended Aug 4, 2026. Not yet confirmed by the SME.',
  },
  // Soo Line Article 25 has NO successive-officer clause (:1738-1802, read whole - forensic audit 2026-10-16): 25(c) sets
  // only OUR 90 days to appeal; no carrier clock on appeal is stated, so none is computed and no default is declared on
  // appeal. (The first draft of this entry said otherwise; it was caught before it went live.)
  'Soo Line Yardmaster Schedule of Rules (eff. Nov 1, 2005)': {
    initialDays: 90, appealDays: null, conferenceDecisionDays: null,
    appealAnswerStated: false,
    provision: 'CLAIM-carrier-response-limits',
    defaultAllowanceProvision: 'CLAIM-carrier-response-limits',
    cites: { initial: 'data/agreements/soo-ym-2005-11-01.source.txt:1747',
             default: 'data/agreements/soo-ym-2005-11-01.source.txt:1749' },
    note: 'Extracted 2026-10-16 from Article 25(b); not yet confirmed by the SME.',
  },
};
